import {FieldConfig} from '../../dynamic-field/field.config';

export interface IconFieldConfig extends FieldConfig<string> {
    click?: () => {};
}
